module.exports = __webpack_public_path__ + "img/active.a027def8.svg";